import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/scheduleManufacturingActions'
import * as api from '../../api/job/scheduleManufacturing'

function* getScheduleManufacturingDates(action) {
  try {
    const payload = yield call(api.getScheduleManufacturingDates, action.jobId)
    yield put({ type: constants.GET_SCHEDULE_MANUFACTURING_DATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SCHEDULE_MANUFACTURING_DATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetScheduleManufacturingDates() {
  yield takeLatest(constants.GET_SCHEDULE_MANUFACTURING_DATES.ACTION, getScheduleManufacturingDates)
}

function* sagaAddScheduleManufacturingDate(action) {
  try {
    const payload = {
      job_id: action.jobId,
      updated_by_id: action.userId,
      created_by_id: action.userId,
      user_id: action.userId,
      schedule_id: action.scheduleId
    }

    yield call(api.addScheduleManufacturingDates, payload)
    yield put({ type: constants.ADD_SCHEDULE_MANUFACTURING_DATE.SUCCESS, payload })
    yield call(getScheduleManufacturingDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_SCHEDULE_MANUFACTURING_DATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddScheduleManufacturingDate() {
  yield takeLatest(
    constants.ADD_SCHEDULE_MANUFACTURING_DATE.ACTION,
    sagaAddScheduleManufacturingDate
  )
}

function* sagaUpdateScheduleManufacturingDates(action) {
  try {
    const payload = {
      job_id: action.jobId,
      schedule_id: action.scheduleId,
      content: action.content,
      updated_by_id: action.userId,
      type: action.scheduleType,
      description: action.description,
      due_date: action.content[action.scheduleType],
      assigned_to_id: 1,
      user_id: 1
    }

    yield call(api.updateScheduleManufacturingDates, payload)
    yield put({ type: constants.SCHEDULE_MANUFACTURING_UPDATE.SUCCESS, payload })
    yield call(getScheduleManufacturingDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_MANUFACTURING_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleManufacturing() {
  yield takeLatest(
    constants.SCHEDULE_MANUFACTURING_UPDATE.ACTION,
    sagaUpdateScheduleManufacturingDates
  )
}

function* sagaDeleteScheduleManufacturing(action) {
  try {
    const payload = {
      schedule_id: action.scheduleId
    }
    yield call(api.deleteScheduleManufacturing, payload)
    yield put({ type: constants.DELETE_SCHEDULE_MANUFACTURING.SUCCESS, payload })
    yield call(getScheduleManufacturingDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_SCHEDULE_MANUFACTURING.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteScheduleManufacturing() {
  yield takeLatest(constants.DELETE_SCHEDULE_MANUFACTURING.ACTION, sagaDeleteScheduleManufacturing)
}

function* sagaUpdateScheduleDrawingNotes(action) {
  try {
    const payload = {
      job_id: action.jobId,
      notes: action.notes,
      updated_by_id: action.userId,
      user_id: 1
    }
    yield call(api.updateScheduleManufacturingNotes, payload)
    yield put({ type: constants.SCHEDULE_MANUFACTURING_UPDATE_NOTE.SUCCESS, payload })
    yield call(getScheduleManufacturingDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_MANUFACTURING_UPDATE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleManufacturingNotes() {
  yield takeLatest(
    constants.SCHEDULE_MANUFACTURING_UPDATE_NOTE.ACTION,
    sagaUpdateScheduleDrawingNotes
  )
}
/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetScheduleManufacturingDates),
    fork(watchUpdateScheduleManufacturing),
    fork(watchUpdateScheduleManufacturingNotes),
    fork(watchAddScheduleManufacturingDate),
    fork(watchDeleteScheduleManufacturing)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/scheduleManufacturingSaga.js